import React from "react";
import "./App.css";
import "./styles/adminSurface.css";
import { AuthProvider } from "./components/common";
import { LogsProvider } from "./components/logs/LogsContext";
import { LicenseProvider } from "./licensing/LicenseProvider";
import { LicenseBanner } from "./licensing/LicenseBanner";
import { Routes, Route } from "react-router-dom";
import SearchBuilder from "./screens/SearchBuilder";
import FlowDesigner from "./screens/FlowDesigner";
import FlowRunner from "./screens/FlowRunner";
import FlowDesignerIsometric from "./screens/FlowDesignerIsometric";
import ProtectedRoute from "./routes/ProtectedRoute";
import AdminRoute from "./routes/AdminRoute";
import SystemLogs from "./pages/SystemLogs";
import Home from "./pages/Home";
import HomeAlternative from "./pages/HomeAlternative";
import HomeCommandCenter from "./pages/HomeCommandCenter";
import Upload from "./pages/Upload";
import AdminHub from "./pages/AdminHub";
import AdminIndexes from "./pages/AdminIndexes";
import ArchivedDatabases from "./pages/ArchivedDatabases";
import BatchProcesses from "./pages/BatchProcesses";
import NotificationsPage from "./pages/NotificationsPage";
import UserGroupAdmin from "./pages/UserGroupAdmin";
import WorkerMonitoring from "./pages/WorkerMonitoring";
import HostManagement from "./pages/HostManagement";
import FleetTopologyPage from "./pages/FleetTopologyPage";
import StorageConfiguration from "./pages/StorageConfiguration";
import DatabaseConfiguration from "./pages/DatabaseConfiguration";
import AuditLogs from "./pages/AuditLogs";
import ContentAccessLogs from "./pages/ContentAccessLogs";
import ContentHoldsPage from "./pages/ContentHoldsPage";
import DispositionPage from "./pages/DispositionPage";
import ClassificationPage from "./pages/ClassificationPage";
import EnrichmentPage from "./pages/EnrichmentPage";
import ContentOrganizationPage from "./pages/ContentOrganizationPage";
import RecordsManagementPage from "./pages/RecordsManagementPage";
import WorkflowPage from "./pages/WorkflowPage";
import MyTasksPage from "./pages/MyTasksPage";
import SharedWithMePage from "./pages/SharedWithMePage";
import DocumentRequestsPage from "./pages/DocumentRequestsPage";
import EDiscoveryPage from "./pages/EDiscoveryPage";
import DeliveryPage from "./pages/DeliveryPage";
import AccessControlPage from "./pages/AccessControlPage";
import AccessReviewPage from "./pages/AccessReviewPage";
import ProcessingConfiguration from "./pages/ProcessingConfiguration";
import Documentation from "./pages/Documentation";
import MetadataSchemas from "./pages/MetadataSchemas";
import Definitions from "./pages/Definitions";
import SystemConfigPage from "./pages/SystemConfigPage";
import LicensePage from "./pages/LicensePage";
import LifecycleRulesPage from "./pages/LifecycleRulesPage";
import LifecycleEventsPage from "./pages/LifecycleEventsPage";
import UpdatePage from "./pages/UpdatePage";
import MonitoringDashboard from "./pages/MonitoringDashboard";
import SignupScreen from "./components/auth/SignupScreen";
import SignupSuccess from "./components/auth/SignupSuccess";
import ConfirmEmail from "./components/auth/ConfirmEmail";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import { LoginScreen } from "./components/auth/LoginScreen";

export default function App() {
  return (
    <LicenseProvider>
      <AuthProvider>
        <LicenseBanner />
      <LogsProvider>
        <Routes>
          <Route path="/login" element={<LoginScreen />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route path="/signup" element={<SignupScreen />} />
          <Route path="/signup/success" element={<SignupSuccess />} />
          <Route path="/confirm-email" element={<ConfirmEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/homealternative"
            element={
              <ProtectedRoute>
                <HomeAlternative />
              </ProtectedRoute>
            }
          />
          {/* A second landing screen, offered for comparison. It is additive in every sense: the live
              home at "/" is untouched, this route is not linked from anywhere, and the page shares no
              component or stylesheet with it. */}
          <Route
            path="/home-command-center"
            element={
              <ProtectedRoute>
                <HomeCommandCenter />
              </ProtectedRoute>
            }
          />
          <Route
            path="/search-builder"
            element={
              <ProtectedRoute>
                <SearchBuilder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/flow-designer"
            element={
              <ProtectedRoute>
                <FlowDesigner />
              </ProtectedRoute>
            }
          />
          <Route
            path="/flow-designer-iso"
            element={
              <ProtectedRoute>
                <FlowDesignerIsometric />
              </ProtectedRoute>
            }
          />
          <Route
            path="/flow-runner"
            element={
              <ProtectedRoute>
                <FlowRunner />
              </ProtectedRoute>
            }
          />
          <Route
            path="/system-logs"
            element={
              <ProtectedRoute>
                <SystemLogs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminHub />
              </AdminRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                <NotificationsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/org-users"
            element={
              <AdminRoute>
                <UserGroupAdmin />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/indexes"
            element={
              <AdminRoute>
                <AdminIndexes />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/lifecycle"
            element={
              <AdminRoute>
                <LifecycleRulesPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/lifecycle-events"
            element={
              <AdminRoute>
                <LifecycleEventsPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/archived-databases"
            element={
              <AdminRoute>
                <ArchivedDatabases />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/batches"
            element={
              <AdminRoute>
                <BatchProcesses />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/workers"
            element={
              <AdminRoute>
                <WorkerMonitoring />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/hosts"
            element={
              <AdminRoute>
                <HostManagement />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/topology"
            element={
              <AdminRoute>
                <FleetTopologyPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/storage-config"
            element={
              <AdminRoute>
                <StorageConfiguration />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/db-config"
            element={
              <AdminRoute>
                <DatabaseConfiguration />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/schemas"
            element={
              <AdminRoute>
                <MetadataSchemas />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/processing-config"
            element={
              <AdminRoute>
                <ProcessingConfiguration />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/audit-logs"
            element={
              <AdminRoute>
                <AuditLogs />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/content-access-logs"
            element={
              <AdminRoute>
                <ContentAccessLogs />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/legal-holds"
            element={
              <AdminRoute>
                <ContentHoldsPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/disposition"
            element={
              <AdminRoute>
                <DispositionPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/classification"
            element={
              <AdminRoute>
                <ClassificationPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/enrichment"
            element={
              <AdminRoute>
                <EnrichmentPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/content-organization"
            element={
              <AdminRoute>
                <ContentOrganizationPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/records-management"
            element={
              <AdminRoute>
                <RecordsManagementPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/workflow"
            element={
              <AdminRoute>
                <WorkflowPage />
              </AdminRoute>
            }
          />
          <Route path="/my-tasks" element={<MyTasksPage />} />
          <Route path="/shared-with-me" element={<SharedWithMePage />} />
          <Route path="/document-requests" element={<DocumentRequestsPage />} />
          <Route
            path="/admin/ediscovery"
            element={
              <AdminRoute>
                <EDiscoveryPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/delivery"
            element={
              <AdminRoute>
                <DeliveryPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/access-control"
            element={
              <AdminRoute>
                <AccessControlPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/access-review"
            element={
              <AdminRoute>
                <AccessReviewPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/definitions"
            element={
              <AdminRoute>
                <Definitions />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/license"
            element={
              <AdminRoute>
                <LicensePage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/update"
            element={
              <AdminRoute>
                <UpdatePage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/monitoring"
            element={
              <AdminRoute>
                <MonitoringDashboard />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/system-config"
            element={
              <AdminRoute>
                <SystemConfigPage />
              </AdminRoute>
            }
          />
          <Route
            path="/documentation"
            element={
              <ProtectedRoute>
                <Documentation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/upload"
            element={
              <ProtectedRoute>
                <Upload />
              </ProtectedRoute>
            }
          />
        </Routes>
      </LogsProvider>
      </AuthProvider>
    </LicenseProvider>
  );
}
